/* eslint-disable sort-keys */

import {
    APPEAR_COMPONENT_DURATION, appearComponent,
} from 'components/Embed/styles/questionnaire'

export const radioWrapper = {
    display: 'flex',
    justifyContent: 'center',
    input: {
        '&:focus-visible': {
            '+ div': {
                outline: '2px solid $questionnaireRadioFocusOutline',
                outlineOffset: '2px',
            },
        },
        'opacity': 0,
        'position': 'absolute',
    },
    label: {
        'textAlign': 'center',
        'width': '100%',
        'justifyContent': 'space-between',
        '> div': {
            'alignItems': 'center',
            'display': 'flex',
            'justifyContent': 'space-between',
            'gap': '10px',
            '> span': {width: '100%'},
        },
        '& svg': {
            color: '$buttonIcon',
            flex: 'none',
            height: '$buttonIcon',
            width: '$buttonIcon',
        },
    },
    margin: '5px 0',
    variants: {
        lightBot: {true: {}},
        currentElement: {true: {}},
        hide: {
            true: {
                visibility: 'hidden',
                height: 0,
                padding: 0,
                overflow: 'hidden',
            },
        },
        inline: {
            true: {
                display: 'inline-flex',
                paddingRight: '10px',
                width: 'auto',
            },
        },
        align: {
            center: {
                'justifyContent': 'center',
                '> div': {width: 'auto'},
            },
            right: {
                'justifyContent': 'flex-end',
                '> div': {width: 'auto'},
            },
            left: {
                'justifyContent': 'flex-start',
                '> div': {width: 'auto'},
            },
        },
        textAlign: {
            center: {},
            left: {'label > div': {textAlign: 'left'}},
            right: {'label > div': {textAlign: 'right'}},
        },
        clearAfter: {true: {'& + *': {clear: 'both'}}},
    },
    compoundVariants: [{
        lightBot: true,
        currentElement: true,
        css: {
            visibility: 'hidden',
            animation: `${appearComponent} ${APPEAR_COMPONENT_DURATION}s $$delay`,
            animationFillMode: 'forwards',
        },
    },
    {
        inline: true,
        align: 'left',
        css: {
            width: 'auto',
            float: 'left',
            display: 'block',
        },
    },
    {
        inline: true,
        align: 'right',
        css: {
            width: 'auto',
            float: 'right',
            display: 'block',
            paddingRight: 0,
        },
    }],
}

export const radioWrapperInner = {
    display: 'flex',
    width: '100%',
}

export const radioButton = {
    'borderRadius': '$button',
    'borderWidth': '$button',
    'fontSize': '$button',
    'fontWeight': '$button',
    'borderStyle': '$button',
    'fontFamily': '$button',
    'lineHeight': '$button',
    'fontStyle': '$button',
    'fontVariant': '$button',
    '& svg': {
        color: '$buttonIcon',
        flex: 'none',
        height: '$buttonIcon',
        width: '$buttonIcon',
    },

    'backgroundColor': '$questionnaireRadioBackground',
    'borderColor': '$questionnaireRadioBorder',
    'boxSizing': 'border-box',
    'color': '$questionnaireRadioText',
    'cursor': 'pointer',
    'flexDirection': 'row',
    'justifyContent': 'center',
    'paddingBottom': '$buttonPaddingVertical',
    'paddingLeft': '$buttonPaddingHorizontal',
    'paddingRight': '$buttonPaddingHorizontal',
    'paddingTop': '$buttonPaddingVertical',
    '&:hover': {
        backgroundColor: '$questionnaireRadioBackgroundHover',
        borderColor: '$questionnaireRadioBorderHover',
        color: '$questionnaireRadioTextHover',
    },
    '&:disabled': {
        '& svg': {color: '$buttonIconDisabled'},
        'cursor': 'not-allowed',
    },
    '&:not(:disabled)': {
        '&:active, &:hover:active': {'& svg': {color: '$buttonIconActive'}},
        '&:focus-visible': {'& svg': {color: '$buttonIconFocus'}},
        '&:hover': {'& svg': {color: '$buttonIconHover'}},
    },
    'variants': {
        checked: {
            true: {
                'backgroundColor': '$questionnaireRadioBackgroundSelected',
                'borderColor': '$questionnaireRadioBorderSelected',
                'color': '$questionnaireRadioTextSelected',
                '&:hover': {
                    backgroundColor: '$questionnaireRadioBackgroundSelected',
                    borderColor: '$questionnaireRadioBorderSelected',
                    color: '$questionnaireRadioTextSelected',
                },
            },
        },

    },
}
